import { showNotification } from "components/v2/notification/notification.js";
import { NEW_HOST_URL } from "config/envConfig.js";

import LocalStorage from "./LocalStorage.js";
const originalFetch = window.fetch;

window.fetch = async function (input, init) {
  const response = await originalFetch(input, init);

  const url = new URL(response.url);

  if (url.origin === NEW_HOST_URL) {
    if (response.status === 403) {
      const newToken = await refreshToken();
      if (!newToken) {
        LocalStorage.removeItem("authToken");
        LocalStorage.removeItem("__uid");
        showNotification({ message: "Session Expired !! Please login again.." });
        setTimeout(() => {
          window.location.pathname = "/login";
        }, 1000);
      }
      LocalStorage.setItem("authToken", newToken);
      init.headers["Authorization"] = `Bearer ${newToken}`;
      return originalFetch(input, init);
    } else if (response.status === 419) {
      LocalStorage.removeItem("authToken");
      LocalStorage.removeItem("__uid");
      showNotification({ message: "Session Expired !! Please login again.." });
      setTimeout(() => {
        window.location.pathname = "/login";
      }, 1000);
    }
  }
  return response;
};

const refreshToken = async () => {
  try {
    const data = {
      userId: LocalStorage.getItem("__uid"),
    };
    const response = await originalFetch(`${NEW_HOST_URL}/refresh`, {
      method: "post",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: LocalStorage.getItem("authToken"),
      },
      body: JSON.stringify(data),
    });
    const dataRes = await response.json();
    return dataRes.data.authToken;
  } catch (e) {
    console.log("Error", e);
  }
};
